<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="isLoading()"
  [totalCount]="totalCount()"
  [clickableRows]="true"
  (pageChange)="onPageChange($event)"
  (rowClick)="onRowClick($event)"
>
  <xemex-table-filter-bar
    [showSearch]="false"
    [filterGroups]="filterGroups()"
    (filterChange)="onPillFilterChange($event)"
  >
    <xemex-filled-button
      actions
      type="button"
      icon="add"
      (click)="openUploadDialog()"
    >
      {{ 'general.btnAdd' | translate }}
    </xemex-filled-button>
  </xemex-table-filter-bar>
</xemex-table>
